import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

export const logisticModels = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_LOGISTIC_MODELS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LOGISTIC_MODELS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_LOGISTIC_MODELS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const logisticModelTasks = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_LOGISTIC_MODEL_TASKS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LOGISTIC_MODEL_TASKS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data.map((x) => {
        return {
          ...x,
          'uniqueId': `${x.serviceCode1}${x.serviceCode2}${x.serviceCode3}`,
        };
      }),
    }),
    [ActionTypes.FETCHED_LOGISTIC_MODEL_TASKS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const targetModelTasks = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_TARGET_LOGISTIC_MODEL_TASKS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TARGET_LOGISTIC_MODEL_TASKS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_TARGET_LOGISTIC_MODEL_TASKS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAN_TARGET_LOGISTIC_MODEL_TASKS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
